import { ComponentFactoryResolver, Inject, Injectable, Type } from '@angular/core';
import { LoggerFactory } from 'app/shared/loggerFactory';
import { ResolverBase } from 'app/views/presentations/shared/resolverBase';
import { Widget } from 'app/views/presentations/widgets/widget';
import { WidgetComponent } from 'app/views/presentations/widgets/widget.component';

import { UnsupportedWidget, UnsupportedWidgetComponent } from './unsupported/unsupported.widget';

@Injectable()
export class WidgetResolver extends ResolverBase<WidgetComponent, Widget> {
    constructor(loggerFactory: LoggerFactory, componentFactoryResolver: ComponentFactoryResolver, @Inject(Widget) widgets: Widget[]) {
        super(loggerFactory.create('WidgetResolver'), componentFactoryResolver, widgets);
    }

    protected getDefaultComponent(): Type<WidgetComponent> {
        return UnsupportedWidgetComponent;
    }

    protected getDefaultComponentMetadata(): Widget {
        return new UnsupportedWidget();
    }
}


// WEBPACK FOOTER //
// ./src/app/views/presentations/widgets/widgetResolver.ts